import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, TextField, Box, Grid, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ApiGetManageRegions,
  ApiPostRegion,
  ApiPostVisitTimes,
  ApiPutRegion,
  ApiPutVisitTimes,
} from "../../../apiService/Core/Apicall.tsx";

interface AddOrUpdateManageVisitProps {
  initialValues?: {
    regionName: string;
    regionCode: string;
    ownerEmail: string;
    teamBccEmail: string;
  };
  onSubmit: (values: any) => void;
  mode: "add" | "update";
}

const AddOrUpdateRegion: React.FC<AddOrUpdateManageVisitProps> = ({
  initialValues = {
    regionName: "",
    regionCode: "",
    ownerEmail: "",
    teamBccEmail: "",
  },
  onSubmit,
}) => {
  const location = useLocation();
  // const region = location?.state?.region;
  const [region, setRegion] = useState([])
  const navigate = useNavigate();
  const { mode, id } = useParams<{ mode: "add" | "update"; id?: string }>();

const handleGetApiCall = async () => {
    const data = `?regionId=${id}`
    try {
      const response: any = await ApiGetManageRegions(data)
      // setRegionList(response.data)
      setRegion(response?.data[0])
    } catch (error) {
      console.error('Error during API call:', error)
    }
  }

  useEffect(()=>{
    id && handleGetApiCall()
  },[id])

  const formik = useFormik({
    initialValues: {
      regionName: region?.regionName || "",
      regionCode: region?.regionCode || "",
      ownerEmail: region?.ownerEmail || "",
      teamBccEmail: region?.teamBccEmail || "",
    },
    validationSchema: Yup.object({
      regionName: Yup.string().required("Region Name is required"),
    }),
    enableReinitialize: true, // This ensures reinitialization when visitTime changes
    onSubmit: (values) => {
      onSubmit(values);
      handleCallApi();
    },
  });


  const handleCallApi = async () => {
    if (mode === "add") {
      try {
        const FormData = {
          regionName: formik.values.regionName,
          regionCode: formik.values.regionCode,
          ownerEmail: formik.values.ownerEmail,
          teamBccEmail: formik.values.teamBccEmail,
          createdBy: Number(localStorage.getItem("createdBy")),
        };
        const response: any = await ApiPostRegion(FormData);
        toast.success("Region added successfully!");
        navigate(-1);
      } catch (error) {
        toast.error(error);
      }
    } else {
      try {
        const FormData = {
          regionId: region.regionId,
          regionName: formik.values.regionName,
          regionCode: formik.values.regionCode,
          ownerEmail: formik.values.ownerEmail,
          teamBccEmail: formik.values.teamBccEmail,
          isActive: true,
          modifiedBy: Number(localStorage.getItem("createdBy")),
        };
        const response: any = await ApiPutRegion(FormData);
        toast.success("Region updated successfully!");
        navigate(-1);
      } catch (error) {
        toast.error(error);
      }
    }
  };

  return (
    <div className="p-3">
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 400,
          margin: "auto",
          padding: 3,
          backgroundColor: "#f9f9f9",
          borderRadius: 2,
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography className="fs-42 text-center mb-3">{mode === "add" ? "Add New Region" : "Update Region"}</Typography>

        <Grid container spacing={2}>
          <Grid size={{xs:12}} sx={{ minWidth: "100%" }}>
            <TextField
              label="Region Name"
              name="regionName"
              value={formik.values.regionName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.regionName && Boolean(formik.errors.regionName)
              }
              fullWidth
            />
          </Grid>

          <Grid size={{xs:12}} sx={{ minWidth: "100%" }}>
            <TextField
              label="Region Code"
              name="regionCode"
              value={formik.values.regionCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.regionCode && Boolean(formik.errors.regionCode)
              }
              fullWidth
            />
          </Grid>

          <Grid size={{xs:12}} sx={{ minWidth: "100%" }}>
            <TextField
              label="Owner Email"
              name="ownerEmail"
              value={formik.values.ownerEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.ownerEmail && Boolean(formik.errors.ownerEmail)
              }
              fullWidth
            />
          </Grid>

          <Grid size={{xs:12}} sx={{ minWidth: "100%" }}>
            <TextField
              label="Team BCC Email"
              name="teamBccEmail"
              value={formik.values.teamBccEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.teamBccEmail &&
                Boolean(formik.errors.teamBccEmail)
              }
              fullWidth
            />
          </Grid>
        </Grid>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="table-row-background"
        >
          {mode === "add" ? "Add Region" : "Update Region"}
        </Button>
      </Box>
    </div>
  );
};

export default AddOrUpdateRegion;
